<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <select v-model="model" class="vendor-input" :disabled="disabled">
      <option
        v-for="(option, index) in bentukBadanUsaha"
        :key="index"
        :value="option.id"
      >
        {{ option.desc }}
      </option>
    </select>
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  props: [
    'modelName',
    'label',
    'mutationName',
    'storeName',
    'isRequired',
    'disabled',
  ],
  data() {
    return {
      bentukBadanUsaha: [],
    }
  },
  created() {
    this.getBentukBadanUsaha()
  },
  computed: {
    model: {
      get() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
  methods: {
    async getBentukBadanUsaha() {
      const { bidang_usaha_id, type_pendaftaran_id } = this.$store.state[
        this.storeName
      ]
      const url = `${api}/api/v1/badan-usaha?page=1&limit=100&bidang_usaha_id=${bidang_usaha_id}&type_pendaftaran_id=${type_pendaftaran_id}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.bentukBadanUsaha = data && data.data
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
  },
}
</script>
